import React from "react";
import * as analysisService from "../../services/kyc/account-analysis-service";
import { Authorize } from "../../components/authorize";
import * as Loader from "../../common/common";
import TextBox from "../../components/form-controls/textbox";
import { commonDownloadPdf } from "../../common/download-pdf";
import * as commonDownloadPdfService from "../../services/pdf/download_pdf_service";
import {
  accountSafranCustDefault,
  accountSchedNewCustDefault,
  accountSafranSuppDefault,
  accountSchedNewSuppDefault,
} from "../../common/const";
import { withRouterProps } from "../../common/hocs";

class AccountAnalysis extends Authorize {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onClear = this.onClear.bind(this);
    this.downloadPdf = this.downloadPdf.bind(this);
  }
  state = {
    clientId: this.props.clientId,
    userType: this.props.clientType,
    AccountAnalysis: {
      clientId: "",
      schedOld: "",
      schedNew:
        this.props.clientType === "Customer"
          ? accountSchedNewCustDefault
          : accountSchedNewSuppDefault,
      misGrp: "",
      safran:
        this.props.clientType === "Customer"
          ? accountSafranCustDefault
          : accountSafranSuppDefault,
      t7: "",
      tds: "",
      serviceTaxRecv: "",
      ccis: "",
      analysis9: "",
      analysis10: "",
    },
    validationErrors: {
      schedOldError: "",
      schedNewError: "",
      misGrpError: "",
      safranError: "",
      t7Error: "",
      tdsError: "",
      serviceTaxRecvError: "",
      ccisError: "",
      analysis9Error: "",
      analysis10Error: "",
    },
    error: "",
    msg: "",
  };

  async downloadPdf(clientId) {
    let data = {
      clientId: clientId,
    };
    let {
      response,
      err,
    } = await commonDownloadPdfService.downloadAccountAnalysis(data);
    if (err) {
    } else if (response.data) {
      commonDownloadPdf(response.data, "AccountAnalysis_" + clientId);
    }
  }

  onChange(e) {
    const value = e.target.value;
    const name = e.target.name;

    if (
      name === "schedOld" ||
      name === "misGrp" ||
      name === "t7" ||
      name === "tds" ||
      name === "serviceTaxRecv" ||
      name === "ccis" ||
      name === "analysis9" ||
      name === "analysis10"
    ) {
      this.setState({
        AccountAnalysis: {
          ...this.state.AccountAnalysis,
          [name]: value.toUpperCase(),
        },
      });
    } else {
      this.setState({
        AccountAnalysis: {
          ...this.state.AccountAnalysis,
          [name]: value,
        },
      });
    }
    let validationErrors = Object.assign({}, this.state.validationErrors);
    if (name === "schedNew") {
      if (!value) {
        validationErrors.schedNewError = "Please enter Schedule VI_New";
      } else {
        validationErrors.schedNewError = "";
      }
    }
    if (name === "safran") {
      if (!value) {
        validationErrors.safranError = "Please enter Safran";
      } else {
        validationErrors.safranError = "";
      }
    }
    this.setState({
      validationErrors: validationErrors,
    });
  }
  onClear() {
    this.setState({
      AccountAnalysis: {
        schedOld: "",
        schedNew:
          this.props.clientType === "Customer"
            ? accountSchedNewCustDefault
            : accountSchedNewSuppDefault,
        misGrp: "",
        safran:
          this.props.clientType === "Customer"
            ? accountSafranCustDefault
            : accountSafranSuppDefault,
        t7: "",
        tds: "",
        serviceTaxRecv: "",
        ccis: "",
        analysis9: "",
        analysis10: "",
      },
      validationErrors: {},
      error: "",
      msg: "",
    });
  }

  componentDidMount() {
    this.getAccountAnalysis();
  }
  async getAccountAnalysis() {
    Loader.showLoader();
    let { response, err } = await analysisService.getAccountAnalysis({
      data: this.state.clientId,
    });
    Loader.hideLoader();
    if (err) {
      this.setState({
        error: err,
        msg: "",
      });
    } else if (response.data && response.data.err) {
      this.setState({
        error: response.data.err,
        msg: "",
      });
    } else {
      if (response.data) {
        this.setState({
          AccountAnalysis: response.data,
        });
      }
    }
  }

  async onSubmit(v, e) {
    Loader.showLoader();
    if (!e) {
      e = v;
    }
    e.preventDefault();
    if (v && v === "prev") {
      this.props.router.navigate(
        "/kycs/" + this.state.clientId + "/" + this.state.userType + "/taxids"
      );
    } else {
      let isSaved = false;
      let {
        schedOld,
        schedNew,
        misGrp,
        safran,
        t7,
        tds,
        serviceTaxRecv,
        ccis,
        analysis9,
        analysis10,
      } = this.state.AccountAnalysis;
      let validationErrors = Object.assign({}, this.state.validationErrors);
      let validationFlag = false;
      if (!schedNew) {
        validationErrors.schedNewError = "Please enter Schedule VI_New";
        validationFlag = true;
      } else {
        validationErrors.schedNewError = "";
      }
      if (this.props.clientType !== "Customer" && !misGrp) {
        validationErrors.misGrpError = "Please enter MIS_GRP";
        validationFlag = true;
      } else {
        validationErrors.misGrpError = "";
      }
      if (!safran) {
        validationErrors.safranError = "Please enter Safran";
        validationFlag = true;
      } else {
        validationErrors.safranError = "";
      }
      var data = Object.assign({}, this.state.AccountAnalysis);
      data.clientId = this.state.clientId;
      data.schedOld = (schedOld && schedOld.trim()) || "";
      data.schedNew = (schedNew && schedNew.trim()) || "";
      data.misGrp = (misGrp && misGrp.trim()) || "";
      data.safran = (safran && safran.trim()) || "";
      data.t7 = (t7 && t7.trim()) || "";
      data.tds = (tds && tds.trim()) || "";
      data.serviceTaxRecv = (serviceTaxRecv && serviceTaxRecv.trim()) || "";
      data.ccis = (ccis && ccis.trim()) || "";
      data.analysis9 = (analysis9 && analysis9.trim()) || "";
      data.analysis10 = (analysis10 && analysis10.trim()) || "";
      if (validationFlag === false) {
        let { response, err } = await analysisService.saveAccountAnalysis(data);
        Loader.hideLoader();
        if (err) {
        } else if (response.data && response.data.err) {
        } else {
          isSaved = true;
          this.setState({
            AccountAnalysis: data,
            msg: response.data.msg,
            error: response.data.err,
          });
          if (isSaved) {
            if (v && v === "next") {
              this.props.router.navigate(
                "/kycs/" +
                  this.state.clientId +
                  "/" +
                  this.state.userType +
                  "/transactionanalysis"
              );
            } else {
              this.getAccountAnalysis();
            }
          }
        }
      } else {
        Loader.hideLoader();
        this.setState({
          validationErrors: validationErrors,
        });
      }
    }
  }
  render() {
    const authorizationResult = super.render();
    if (authorizationResult) {
      return authorizationResult;
    }

    let {
      schedOld,
      schedNew,
      misGrp,
      safran,
      t7,
      tds,
      serviceTaxRecv,
      ccis,
      analysis9,
      analysis10,
    } = this.state.AccountAnalysis;
    let {
      schedOldError,
      schedNewError,
      misGrpError,
      safranError,
      t7Error,
      tdsError,
      serviceTaxRecvError,
      ccisError,
      analysis9Error,
      analysis10Error,
    } = this.state.validationErrors;
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-md-12">
              <button
                className="float-right btn btn-md btn-info"
                title="Download PDF"
                onClick={this.downloadPdf.bind(this, this.state.clientId)}
              >
                <i className="fa fa-download"></i> PDF{" "}
              </button>
            </div>

            <div className="col-md-12">
              <form onSubmit={this.onSubmit}>
                {/* <h3 style={{ textAlign: "center" }}>Client Account Analysis</h3> */}

                {this.state.msg ? (
                  <p className="text" style={{ color: "green" }}>
                    {this.state.msg}
                  </p>
                ) : null}
                {this.state.error ? (
                  <p className="text" style={{ color: "red" }}>
                    {this.state.error}
                  </p>
                ) : null}
                <div className="row">
                  <div className="col-sm-4">
                    {/* <label className="col-form-label">Schedule VI_Old</label>
                                                    <input className={schedOldError ? "is-invalid form-control" : "form-control"} type="text" placeholder="Schedule VI_Old" maxLength="300" name="schedOld" value={schedOld || ''} onChange={this.onChange} autoComplete="off" />
                                         <span className="error-msg">{schedOldError}</span> */}
                    <TextBox
                      type="text"
                      animatedClass="fg-animate"
                      name="schedOld"
                      label="Schedule VI_Old"
                      value={schedOld || ""}
                      maxLength="300"
                      error={schedOldError}
                      onChange={this.onChange}
                    />
                  </div>
                  <div className="col-sm-4">
                    {/* <label className="col-form-label">Schedule VI_New<span className="mandatory">*</span></label>
                                                    <input className={schedNewError ? "is-invalid form-control" : "form-control"} type="text" placeholder="Schedule VI_New" maxLength="300" name="schedNew" value={schedNew || ''} onChange={this.onChange} autoComplete="off" />
                                                    <span className="error-msg">{schedNewError}</span> */}
                    <TextBox
                      type="text"
                      animatedClass="fg-animate"
                      name="schedNew"
                      label="Schedule VI_New"
                      value={schedNew || ""}
                      required={true}
                      maxLength="300"
                      error={schedNewError}
                      onChange={this.onChange}
                    />
                  </div>
                  <div className="col-sm-4">
                    {/* <label className="col-form-label">MIS_Grp<span className="mandatory">*</span></label>
                                                    <input className={misGrpError ? "is-invalid form-control" : "form-control"} type="text" placeholder="MIS_Grp" maxLength="300" name="misGrp" value={misGrp || ''} onChange={this.onChange} autoComplete="off" />
                                                    <span className="error-msg">{misGrpError}</span> */}
                    {this.props.clientType === "Customer" ? (
                      <TextBox
                        type="text"
                        animatedClass="fg-animate"
                        name="misGrp"
                        label="MIS_Grp"
                        value={misGrp || ""}
                        maxLength="300"
                        error={misGrpError}
                        onChange={this.onChange}
                      />
                    ) : (
                      <TextBox
                        required="true"
                        type="text"
                        animatedClass="fg-animate"
                        name="misGrp"
                        label="MIS_Grp"
                        value={misGrp || ""}
                        maxLength="300"
                        error={misGrpError}
                        onChange={this.onChange}
                      />
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-4">
                    {/* <label className="col-form-label">Safran<span className="mandatory">*</span></label>
                                                    <input className={safranError ? "is-invalid form-control" : "form-control"} type="text" placeholder="Safran" maxLength="150" name="safran" value={safran || ''} onChange={this.onChange} autoComplete="off" />
                                                    <span className="error-msg">{safranError}</span> */}
                    <TextBox
                      type="text"
                      animatedClass="fg-animate"
                      name="safran"
                      label="Safran"
                      value={safran || ""}
                      required={true}
                      maxLength="150"
                      error={safranError}
                      onChange={this.onChange}
                    />
                  </div>
                  <div className="col-sm-4">
                    {/* <label className="col-form-label">T7-CUS/SUPP</label>
                                                    <input className={t7Error ? "is-invalid form-control" : "form-control"} type="text" placeholder="T7-CUS/SUPP" name="t7" maxLength="300" value={t7 || ''} onChange={this.onChange} autoComplete="off" />
                                                    <span className="error-msg">{t7Error}</span> */}
                    <TextBox
                      type="text"
                      animatedClass="fg-animate"
                      name="t7"
                      label="T7-CUS/SUPP"
                      value={t7 || ""}
                      maxLength="300"
                      error={t7Error}
                      onChange={this.onChange}
                    />
                  </div>
                  <div className="col-sm-4">
                    {/* <label className="col-form-label">TDS</label>
                                                    <input className={tdsError ? "is-invalid form-control" : "form-control"} type="text" placeholder="TDS" maxLength="300" name="tds" value={tds || ''} onChange={this.onChange} autoComplete="off" />
                                                    <span className="error-msg">{tdsError}</span> */}
                    <TextBox
                      type="text"
                      animatedClass="fg-animate"
                      name="tds"
                      label="TDS"
                      value={tds || ""}
                      maxLength="300"
                      error={tdsError}
                      onChange={this.onChange}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-4">
                    {/* <label className="col-form-label">Service Tax Receivable Category</label>
                                                    <input className={serviceTaxRecvError ? "is-invalid form-control" : "form-control"} type="text" placeholder="Service Tax Receivable Category" maxLength="300" name="serviceTaxRecv" value={serviceTaxRecv || ''} onChange={this.onChange} autoComplete="off" />
                                                    <span className="error-msg">{serviceTaxRecvError}</span> */}
                    <TextBox
                      type="text"
                      animatedClass="fg-animate"
                      name="serviceTaxRecv"
                      label="Service Tax Receivable Category"
                      value={serviceTaxRecv || ""}
                      maxLength="300"
                      error={serviceTaxRecvError}
                      onChange={this.onChange}
                    />
                  </div>
                  <div className="col-sm-4">
                    {/* <label className="col-form-label">CCIS Group Code</label>
                                                    <input className={ccisError ? "is-invalid form-control" : "form-control"} type="text" placeholder="CCIS Group Code" maxLength="300" name="ccis" value={ccis || ''} onChange={this.onChange} autoComplete="off" />
                                                    <span className="error-msg">{ccisError}</span> */}
                    <TextBox
                      type="text"
                      animatedClass="fg-animate"
                      name="ccis"
                      label="CCIS Group Code"
                      value={ccis || ""}
                      maxLength="300"
                      error={ccisError}
                      onChange={this.onChange}
                    />
                  </div>
                  <div className="col-sm-4">
                    {/* <label className="col-form-label">Analysis Code 9</label>
                                                    <input className={analysis9Error ? "is-invalid form-control" : "form-control"} type="text" placeholder="Analysis Code 9" maxLength="300" name="analysis9" value={analysis9 || ''} onChange={this.onChange} autoComplete="off" />
                                                    <span className="error-msg">{analysis9Error}</span> */}
                    <TextBox
                      type="text"
                      animatedClass="fg-animate"
                      name="analysis9"
                      label="Analysis Code 9"
                      value={analysis9 || ""}
                      maxLength="300"
                      error={analysis9Error}
                      onChange={this.onChange}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-4">
                    {/* <label className="col-form-label">Analysis Code 10</label>
                                                    <input className={analysis10Error ? "is-invalid form-control" : "form-control"} type="text" placeholder="Analysis Code 10" maxLength="300" name="analysis10" value={analysis10 || ''} onChange={this.onChange} autoComplete="off" />
                                                    <span className="error-msg">{analysis10Error}</span> */}
                    <TextBox
                      type="text"
                      animatedClass="fg-animate"
                      name="analysis10"
                      label="Analysis Code 10"
                      value={analysis10 || ""}
                      maxLength="300"
                      error={analysis10Error}
                      onChange={this.onChange}
                    />
                  </div>
                </div>
                <div className="float-right">
                  <button
                    className="btn btn-md btn-default"
                    type="button"
                    onClick={this.onClear}
                  >
                    Clear
                  </button>
                  &nbsp;
                  <button
                    className="btn btn-md btn-primary"
                    type="button"
                    onClick={this.onSubmit.bind(this, "prev")}
                  >
                    Previous
                  </button>
                  &nbsp;
                  <button
                    className="btn btn-md btn-success"
                    type="submit"
                    onClick={this.onSubmit}
                  >
                    Save
                  </button>
                  &nbsp;
                  <button
                    className="btn btn-md btn-warning"
                    type="button"
                    onClick={this.onSubmit.bind(this, "next")}
                  >
                    Save and Next
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* </div> */}
        {/* <div style={{ textAlign: "center" }}>
                <Link to="/Login">Back to Login</Link>
            </div> */}
      </React.Fragment>
    );
  }
}

// Custom HOC to inject router props to use React Router v6 hooks in class components
export default withRouterProps(AccountAnalysis);